export default {
	tab: "Reservas",
	reserveConsultant: "Reservar consulente",
	pending: "Pendentes",
	confirmed: "E-mail confirmado",
	awaitingConfirm: "E-mail não confirmado",
	receivedAt: "Recebida em",
	noEmailStatus: "Sem e-mail",
	viewDetails: "Ver detalhes",
	phone: "Telefone",
	email: "E-mail",
	approve: "Aprovar",
	reject: "Recusar",
	expected: "Reservados",
	noExpected: "Ninguém reservado ainda.",
	noPending: "Nenhuma reserva pendente.",
	noRejected: "Nenhuma reserva recusada.",
	originPublic: "Pública",
	originInternal: "Interna",
	rejected: "Recusadas",
	approveTitle: "Aprovar reserva",
	linkExisting: "Consulente existente",
	createNew: "Cadastrar novo",
	consultant: "Consulente",
	attendanceType: "Tipo de atendimento",
	groupByType: "Agrupar por tipo de atendimento",
	noType: "Sem tipo",
	attendanceTypeHint: "A reserva garante ficha desse tipo; tipos lotados ficam indisponíveis.",
	unlimited: "sem limite",
	full: "lotado",
	selectType: "Selecione o tipo de atendimento.",
	firstName: "Nome",
	lastName: "Sobrenome",
	rejectTitle: "Recusar reserva",
	rejectReason: "Motivo (opcional)",
	notes: "Observação (opcional)",
	reserve: "Reservar",
	reserved: "Consulente reservado!",
	approved: "Reserva aprovada!",
	rejectedDone: "Reserva recusada.",
	loadError: "Erro ao carregar as reservas.",
	saveError: "Não foi possível concluir. Tente novamente.",
	selectConsultant: "Selecione o consulente.",
	firstNameRequired: "Informe o nome.",
	attended: "Atendida",
	cancelReservation: "Cancelar reserva",
	editTitle: "Editar reserva",
	cancelTitle: "Cancelar reserva",
	cancelConfirm: 'Cancelar a reserva de "{name}"? A vaga será liberada.',
	saved: "Reserva atualizada!",
	cancelled: "Reserva cancelada.",
	exportExcel: "Excel",
	printTitle: "Reservas do ritual",
	origin: "Origem",
	status: "Status",
	awaitingAttendance: "Aguardando",
	contact: "Contato",
};
